import React, { useEffect, useState, useRef, useMemo } from 'react';
import { ShareFat, FileMagnifyingGlass, ChartLineUp, UserFocus, CaretLeft, HandCoins, Info, X } from '@phosphor-icons/react';
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Icon, Select, Sidebar, Modal, notify } from 'app/components';
import { formatTimestampWithStartDate } from '../../../../event-list/util';
import { approveEvent, deleteEvent, getEventById, updateEvent } from './api';
import { AttendeesTable, BookingDetails, Dashboard, EventDetails, Tickets } from '../../../../event-dashboard/containers';
import { cancelEvent, sendDirectOtp, verifyDirectOtp } from '../../../../event-dashboard/api';
import { getBookingRefundInfo } from '../../../../booking/api';
import { generateUniqueId } from '../../../../event-create/containers/step-3/utils';
import { isPast } from 'date-fns';
import OTPInput from 'react-otp-input';
import RefundDashboard from '../../../../event-dashboard/containers/refundDashboard/refundDashboard';

const eventDetailsSections = ['about', 'locale', 'image', 'description', 'note'];


const checkItems = [
  {
    label: 'Event details',
    check: true,
    subItems: [
      { label: 'About', value: 'about' },
      { label: 'When and where?', value: 'locale'},
      { label: 'Image', value: 'image'},
      { label: 'Event Description', value: 'description'},
      { label: 'Terms and Conditions', value: 'note'},
    ],
  },
  { label: 'Tickets', check: true, value: 'tickets'},
  { label: 'Booking details', check: true, value: 'bookingDetails' },
];

const countMap = {
  0: 60,
  1: 180,
  2: 300,
  3: 420,
  4: 600,
};

const TmtEventEdit = () => {
  const [activeSection, setActiveSection] = useState('about');
  const [selectedItem, setSelectedItem] = useState('about');
  const [approveModal, setApproveModal] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpText, setOtpText] = useState('');
  const [otpError, setOtpError] = useState('');
  const [seconds, setSeconds] = useState(0);
  const [resendLinkCount, setResendLinkCount] = useState(0);
  const [refundInfo, setRefundInfo] = useState(null);
  const interval = useRef(null);
  const totalCount = useRef(0);
  const params = useParams();
  const navigate = useNavigate();
  const uniqIdentifier = useRef(null);
  const [approveLoading, setApproveLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const PHNO = '9944253807';
  
  const { eventDetails } = useSelector((state) => state.adminPrimaryEventEdit);

  const menuItems = [
    ...(eventDetails?.status === 'CANCELLED' || eventDetails?.is_reschedule === true
      ? [{
          label: 'Refund Dashboard',
          value: 'RefundDashboard',
          icon: <HandCoins size={24} />,
        }]
      : []),
    {
      label: 'Dashboard',
      value: 'dashboard',
      icon: <ChartLineUp size={24} />,
    },
    {
      label: 'Attendees',
      value: 'attendees',
      icon: <UserFocus size={24} />,
    },
  ];

  const [isCancelled, setIsCancelled] = useState(null);

  const { startTime, endTime } = formatTimestampWithStartDate(eventDetails?.start_date, eventDetails?.end_date);

  console.log(eventDetails);
  
  useEffect(() => {
    if (eventDetails?.id && (eventDetails?.status === 'CANCELLED' || eventDetails?.is_reschedule === true))
    {
      getBookingRefundInfo(eventDetails?.id, (response) => {
        console.log("Raw API Response:", response);
        setRefundInfo(response);
      });
    }
    if (params?.eventId) getEventById(params.eventId);
  }, [params?.eventId, eventDetails?.id, eventDetails?.status, eventDetails?.is_reschedule]);


  console.log(refundInfo);

  const onClickBack = () => {
    navigate('/admin/primary/events');
  };

  const onApproveEvent = () => {
    setApproveLoading(true);
    approveEvent(params?.eventId, { ...eventDetails, id: 0 }, () => {
      setApproveModal(false);
      setApproveLoading(false);
      notify('success', 'Event is approved');
    }, () => {
      setApproveLoading(false);
      notify('error', 'Failed to approve event');
    });
  };

  const onDeleteEvent = () => {
    setDeleteLoading(true);
    deleteEvent(params?.eventId, eventDetails?.status !== 'APPROVED', () => {
      navigate('/admin/primary/events');
      setShowDeleteConfirmation(false);
      setDeleteLoading(false);
    });
  };


  const handleCancelEvent = async () => {
    try {
      console.log('Sending OTP...');
      uniqIdentifier.current = generateUniqueId();
      sendDirectOtp(PHNO, uniqIdentifier.current, 
        (data) => {
          notify('success', 'OTP sent successfully');
          setShowOtpModal(true);
        }, 
        (error) => {
          console.error('Failed to send OTP:', error);
          notify('error', 'Failed to send OTP');
        }
      );
    } catch (err) {
      console.error('Error in handleCancelEvent:', err);
      notify('error', 'Failed to send OTP');
    }
  };

  const handleOtpChange = (otp) => {
    const otpCode = otp.replace(/\D/g, '');
    setOtpText(otpCode);
    setOtpError('');

    if (otpCode.length === 4 && !/^[0-9]{4}$/.test(otpCode)) {
      setOtpError('Please enter correct OTP');
    }
  };

  const handleVerifyOtp = (otp) => {
    if (!otpError && otp?.length === 4) {
      verifyDirectOtp(PHNO, uniqIdentifier.current, otp, 
        (data) => {
          console.log('OTP verification response:', data);
          if (data?.status === 'success') {
            setShowOtpModal(false);
            setShowCancelModal(true);
          } else {
            setOtpError(data?.reason || 'Please enter correct OTP');
          }
        }, 
        (error) => {
          console.error('OTP verification failed:', error);
          setOtpError('Please enter correct OTP');
        }
      );
    } else {
      setOtpError('Please enter correct OTP');
    }
  };

  const handleConfirmCancel = () => {
    cancelEvent(eventDetails?.id, 
      (response) => {
        setShowCancelModal(false);
        setIsCancelled(false);
        notify('success', 'Event is cancelled');
      }
    );
  };

  const onClickResend = () => {
    if (seconds === 0) {
      if (totalCount.current <= 5) {
        uniqIdentifier.current = generateUniqueId();
        sendDirectOtp(PHNO, uniqIdentifier.current, 
          (data) => {
            console.log('OTP sent successfully:', data);
            notify('success', "OTP sent successfully");
            setOtpText('');
            setOtpError('');
          }, 
          (error) => {
            console.error('Failed to send OTP:', error);
            notify('error', 'Failed to send OTP');
          }
        );
        if (countMap[totalCount.current]) {
          setResendLinkCount((prev) => prev + 1);
          setSeconds(countMap[totalCount.current]);
          totalCount.current = totalCount.current + 1;
        }
      } else {
        notify('error', 'You have exceeded the resend otp limit!');
      }
    } else {
      console.log('Enter a code to proceed');
    }
  };

  useMemo(() => {
    if (resendLinkCount) {
      interval.current = setInterval(() => {
        if (seconds) setSeconds((prev) => prev - 1);
      }, 1000);
    } else clearInterval(interval.current);
  }, [resendLinkCount]);

  const resendLabel = useMemo(() => {
    if (seconds === 0) {
      setResendLinkCount(0);
      return 'Click to resend.';
    }
    if (resendLinkCount) {
      return `Resend in ${seconds} seconds`;
    }
    return 'Click to resend.';
  }, [resendLinkCount, seconds]);

  const headerContent = (
    <div className='event-content flex flex-col gap-2 border-b border-grey-10 pb-6'>
      <Icon
        className="cursor-pointer"
        type="circle"
        onClick={onClickBack}
      >
        <CaretLeft
          color="#101010"
          size={16}
        />
      </Icon>
      <div className='heading-24'>{eventDetails?.name}</div>
      <div className='text-16 flex gap-0.5 text-grey-70'>{startTime} to {endTime}</div>
      {eventDetails?.is_active && !isPast(new Date(eventDetails?.end_date)) && eventDetails?.status !== 'CANCELLED' && isCancelled === null && (
        <Button
          type="button"
          onClick={handleCancelEvent}
          className="flex items-center justify-center gap-2 w-full border border-gray-300 rounded-full px-4 py-2 text-black bg-white shadow-sm hover:bg-gray-100 transition"
        >
          <X className="w-5 h-5" />
          Cancel Event
        </Button>
      )}
      {(eventDetails?.status === "CANCELLED" || (isCancelled != null)) &&
      <div className="flex items-center gap-3 px-8 py-5 rounded-xl bg-[#FFF4F4] w-full">
        <Info size={20} color="#D92D20" />
        <span className="text-[#D92D20] text-sm font-medium">Event Cancelled</span>
      </div>}
      {eventDetails?.status !== "CANCELLED" && (eventDetails?.is_reschedule == true) &&
      <div className="flex items-center gap-3 px-8 py-5 rounded-xl bg-[#E5FFF6] w-full">
        <Info size={20} color="green" />
        <span className="text-[green] text-sm font-medium">Rescheduled Event</span>
      </div>}
      {eventDetails?.business_config_id && (<div className='flex gap-2 py-1'>
        <Select
          icon={<FileMagnifyingGlass color="#101010" 
            size={20} />}
          label="Go to Organizer Details"
          onClick={() => navigate(`/admin/primary/organizers/${eventDetails?.business_config_id}`)}
          className='w-full px-6 py-5 whitespace-nowrap'
          width="100%"
        />
      </div>)}
      {(eventDetails?.status !== 'APPROVED' && eventDetails?.status !== 'CANCELLED') && (
        <Button
          onClick={() => setApproveModal(true)}
        >
          Approve this event
        </Button>)}
    </div>
  );

  const handleMenuClick = (item) => {
    setSelectedItem(item); 
    setActiveSection(item.value);
  };

  const onChange = (data, successMsg, callback) => {
    updateEvent(params.eventId, data, (value) => {
      if (callback) callback(value);
      notify(
        'success', successMsg, 
        { position: 'bottom-center', duration: 2000 },
      );
    });
  };

  return (
    <div className='flex h-full overflow-y-hidden primary-event-edit'>
    <Sidebar
      header={headerContent}
      menuItems={((eventDetails?.status === 'APPROVED' || eventDetails?.status === 'CANCELLED') || eventDetails?.is_reschedule === true ) ? menuItems : []}
      checkItems={checkItems}
      onMenuClick={handleMenuClick}
      selectedItem={selectedItem}
      className="dashboard-sidebar"
      colorMode="black"
      width="330px"
    >
        <div
          className='text-error label-16 underline cursor-pointer'
          onClick={() => setShowDeleteConfirmation(true)}
        >Delete Event</div>
      </Sidebar>
    <div className='flex flex-column flex-1 overflow-auto'>

    {activeSection === 'dashboard' && (<Dashboard stateName="adminPrimaryEventEdit" />)}

    {activeSection === 'attendees' && (<AttendeesTable stateName="adminPrimaryEventEdit" dispatchText="ADMIN_PRIMARY_EVENT_EDIT:ATTENDEES_LIST:SET" />)}

    {activeSection === 'RefundDashboard' && (<RefundDashboard refundInfo = {refundInfo} stateName = "adminPrimaryEventEdit"/>)}

    {eventDetailsSections.includes(activeSection) && 
      <EventDetails activeSection={activeSection}
        formattedDate={`${startTime} - ${endTime}`}
        onChange={onChange}
        isAdmin={true}
        stateName="adminPrimaryEventEdit"
      />
    }

    {activeSection === 'tickets' && <Tickets stateName="adminPrimaryEventEdit" onChange={onChange} isAdmin={true} />}
    
    {activeSection === 'bookingDetails' && <BookingDetails stateName="adminPrimaryEventEdit" onChange={onChange} isAdmin={true} />}
    

    </div>
    <Modal
      className="approve-confirmation-modal"
      size="regular"
      isOpen={approveModal}
      title="Are you sure you want to approve this event?"
      customFooter={
        <div className="modal-footer flex">
          <Button
            className="secondary-cta"
            type="tertiary"
            onClick={() => setApproveModal(false)}
            disabled={approveLoading}
          >
            Cancel
          </Button>
          <Button
            className="primary-cta"
            type="primary-black"
            onClick={onApproveEvent}
            loading={approveLoading}
            disabled={approveLoading}
          >
            Approve
          </Button>
        </div>
      }
    />
    <Modal
      className="delete-confirmation-modal"
      size="regular"
      isOpen={showDeleteConfirmation}
      title="Are you sure you want to delete this event?"
      customFooter={
        <div className="modal-footer flex">
          <Button
            className="secondary-cta"
            type="tertiary"
            onClick={() => setShowDeleteConfirmation(false)}
            disabled={deleteLoading}
          >
            Cancel
          </Button>
          <Button
            className="primary-cta"
            type="primary-black"
            onClick={onDeleteEvent}
            loading={deleteLoading}
            disabled={deleteLoading}
          >
            Delete
          </Button>
        </div>
      }
    />
    <Modal
      isOpen={showOtpModal}
      className="otp-modal"
      hasClose={false}
      title={<div className='bg-grey-10 p-2 rounded-full'><CaretLeft size={16} className="cursor-pointer" onClick={() => setShowOtpModal(false)}/></div>}
      primaryText="Confirm"
      onClickPrimaryCta={() => handleVerifyOtp(otpText)}
      disabled={otpText.length !== 4}
      size="regular"
      secondaryText={false}
    >
      <>
        <div className="flex flex-row justify-start gap-6 heading-24 pb-3">
          Please enter your OTP
        </div>
        <div className="text-16">
          We've sent a 4 digit confirmation code to {PHNO}
        </div>
        <div className={`label-16 pt-8 block ${otpError ? 'text-[#D92D20]' : 'text-grey-70'}`}>
          OTP
        </div>
        <OTPInput
          value={otpText}
          onChange={handleOtpChange}
          isInputNum={true}
          numInputs={4}
          renderSeparator={null}
          shouldAutoFocus={true}
          containerStyle="otp-container"
          inputStyle={`otp-input ${otpError ? 'error' : ''}`}
          renderInput={(props) => (
            <input {...props} value={props.value} />
          )}
        />
        {otpError && (
          <span className="otp-helptext text-14 text-error">
            {otpError}
          </span>
        )}
        <span className="otp-helptext text-14 flex gap-1 pt-3">
          Didn't get a code?
          <Button
            className={`font-bold resend-button ${seconds !== 0 ? 'resend-button.disabled' : 'text-slate-950'}`}
            children={resendLabel}
            disabled={seconds !== 0 || totalCount.current > 5}
            type="tertiary-text-underlined"
            onClick={onClickResend}
          />
        </span>
      </>
    </Modal>
    <Modal
      isOpen={showCancelModal}
      className="cancel-event-modal"
      hasClose={true}
      onClose={() => setShowCancelModal(false)}
      title="Are you sure you want to cancel this event?"
      primaryText="Yes"
      secondaryText="Cancel"
      onClickPrimaryCta={handleConfirmCancel}
      onClickSecondaryCta={() => setShowCancelModal(false)}
      size="regular"
    >
    </Modal>
  </div>
  );
};

export default TmtEventEdit;
